import * as XLSX from 'xlsx'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleExportXlsx = async (filename: string, values: any[], sheetName?: string) => {
	const workbook = XLSX.utils.book_new()

	const worksheet = XLSX.utils.json_to_sheet(values)
	XLSX.utils.book_append_sheet(workbook, worksheet, sheetName || 'Sheet 1')

	XLSX.writeFile(workbook, filename, { compression: true })
}

export { handleExportXlsx }
